import { useLoad } from "../lib/api.jsx";
import { Wait, Tbl } from "../lib/ui.jsx";

export default function AuditLog() {
  const [d] = useLoad("logs");
  return (
    <>
      <h1>Admin audit</h1>
      <Wait d={d}>
        {d && !d.error && (
          <div style={{ marginTop: 12 }}>
            <Tbl rows={d.rows} empty="No admin actions recorded yet." cols={[
              ["When", (l) => l.time_stamp], ["Admin", (l) => l.admin || "-"], ["Action", (l) => l.act_type],
              ["Details", (l) => l.action], ["Target", (l) => l.target || "-"],
            ]} />
          </div>
        )}
      </Wait>
    </>
  );
}
